import { Box, Typography, useTheme } from "@material-ui/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { mainContrast } from "../hooks/use-map-theme-styles";
import startUpper from "../utils/start-upper";
import MappedComponent from "./mapped-components/MappedComponent";

interface ProgressBarProps {
	total: number;
	progress: number;
	accepted?: number;
	declined?: number;
}

interface TooltipProgressBarProps {
	accepted: number;
	declined: number;
	total: number;
}

const TooltipProgressBar: React.FC<TooltipProgressBarProps> = ({ accepted, declined, total }) => {
	const { palette } = useTheme();
	const { t } = useTranslation();

	return (
		<Box p={1}>
			<Box display="flex" width="250px" alignItems="center" justifyContent="space-between">
				<Typography style={{ width: "35%" }}>{startUpper(t("APPROVED"))}</Typography>
				<Box
					style={{
						display: "flex",
						width: "60%",
						height: "6px",
						borderRadius: "10px",
						backgroundColor: mainContrast,
					}}
				>
					<Box
						style={{
							backgroundColor: palette.primary.main,
							width: `${(accepted * 100) / total}%`,
							borderTopLeftRadius: "10px",
							borderBottomLeftRadius: "10px",
							borderTopRightRadius: total === accepted ? "10px" : "0px",
							borderBottomRightRadius: total === accepted ? "10px" : "0px",
						}}
					></Box>
				</Box>
				<Typography>{accepted}</Typography>
			</Box>

			<Box display="flex" width="250px" alignItems="center" justifyContent="space-between">
				<Typography style={{ width: "35%" }}>{startUpper(t("DECLINED"))}</Typography>
				<Box
					style={{
						display: "flex",
						width: "60%",
						height: "6px",
						borderRadius: "10px",
						backgroundColor: mainContrast,
					}}
				>
					<Box
						style={{
							backgroundColor: palette.primary.main,
							width: `${(declined * 100) / total}%`,
							borderTopLeftRadius: "10px",
							borderBottomLeftRadius: "10px",
							borderTopRightRadius: total === declined ? "10px" : "0px",
							borderBottomRightRadius: total === declined ? "10px" : "0px",
						}}
					></Box>
				</Box>
				<Typography>{declined}</Typography>
			</Box>
		</Box>
	);
};

const ProgressBar: React.FC<ProgressBarProps> = ({ total, progress, accepted, declined }) => {
	const { palette } = useTheme();
	const [showToolTip, setShowTooltip] = useState(false);

	const isTooltipActive = accepted !== undefined || declined !== undefined;

	const props = {
		title: <TooltipProgressBar total={total} accepted={accepted || 0} declined={declined || 0} />,
		open: showToolTip && isTooltipActive,
		variant: "light",
		children: (
			<Box
				onMouseEnter={() => setShowTooltip(true)}
				onMouseLeave={() => setShowTooltip(false)}
				style={{
					display: "flex",
					width: "100%",
					height: "6px",
					borderRadius: "10px",
					backgroundColor: mainContrast,
				}}
			>
				<Box
					style={{
						backgroundColor: palette.primary.main,
						width: `${(progress * 100) / total}%`,
						borderTopLeftRadius: "10px",
						borderBottomLeftRadius: "10px",
						borderTopRightRadius: total === progress ? "10px" : "0px",
						borderBottomRightRadius: total === progress ? "10px" : "0px",
					}}
				></Box>
			</Box>
		),
	};
	return <MappedComponent component="Tooltip" props={props} />;
};

export default ProgressBar;
